import React from 'react';
import { colors, font } from '../../lib/tokens';

type PeakLogoProps = {
  color?: string;
  accent?: string;
  size?: number;
  showText?: boolean;
  weight?: number;
  track?: number;
};

// Peak · Fault — the mark the founder picked. Twin peaks offset along a
// fault line, accent color exposed in the crack between them.
// Ported 1:1 from logos.jsx → LogoPeakFault.
let faultIdCounter = 0;
function useFaultClipId() {
  const [id] = React.useState(() => `peak-fault-clip-${++faultIdCounter}`);
  return id;
}

export default function PeakLogo({
  color = colors.ink,
  accent = colors.blue,
  size = 40,
  showText = true,
  weight = 600,
  track = -0.4,
}: PeakLogoProps) {
  const clipId = useFaultClipId();
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <defs>
          <clipPath id={clipId}>
            <path d="M2 33L16 9l14 24H2z" />
          </clipPath>
        </defs>
        {/* Back peak, slightly raised and dimmed — creates the fault offset.
            The kc-peak-* classes let a hovered `.kc-logo-link` shift the
            peaks along the fault (index.css). */}
        <path className="kc-peak-back" d="M12 33L26 14l12 19H12z" fill={color} opacity={0.25} />
        {/* Front peak, filled */}
        <path d="M2 33L16 9l14 24H2z" fill={color} />
        {/* Accent band exposed through the fault gap */}
        <g clipPath={`url(#${clipId})`}>
          <rect className="kc-peak-accent" x={14} y={0} width={20} height={40} fill={accent} opacity={0.9} />
        </g>
        {/* Outline re-emphasises the front silhouette */}
        <path d="M2 33L16 9l14 24H2z" fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" />
      </svg>
      {showText && (
        <span
          style={{
            fontFamily: font.sans,
            fontWeight: weight,
            fontSize: size * 0.55,
            letterSpacing: track,
            color,
          }}
        >
          katlacode
        </span>
      )}
    </span>
  );
}
